import React from 'react';
import Layout from '../components/Layout';
import { User, Code, Folder, Mail } from 'lucide-react';
import './Home.css';

const Home: React.FC = () => {
  return (
    <Layout>
      <section className="hero">
        <h2>Welcome to my portfolio!</h2>
        <p>渡邊 磨王斗と申します。修士1年で情報アクセス技術の研究をしています。</p>
      </section>

      <section className="intro">
        <h3>このサイトで紹介していること</h3>
        <ul className="icon-list">
          <li><User size={18} /> 自己紹介と経歴</li>
          <li><Code size={18} /> 使用している技術スタック</li>
          <li><Folder size={18} /> 研究・制作物の紹介</li>
          <li><Mail size={18} /> お問い合わせ情報</li>
        </ul>
      </section>
    </Layout>
  );
};

export default Home;



  